import React from 'react';
import PropTypes from 'prop-types';
import styles from './Card.module.css';

const Card = ({ title, children, isLoading = false, LoadingComponent = null }) => {
  return (
    <div className={styles.card}>
      {isLoading && LoadingComponent}
      <div className={styles.cardHeader}>
        {title}
      </div>
      <div className={styles.cardBody}>
        {children}
      </div>
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  LoadingComponent: PropTypes.node
};

Card.defaultProps = {
  isLoading: false,
  LoadingComponent: null
};

export default Card;